export const PERMISSIONS = {
    Admin: "autorizacao-cibio.admin",
    Visitante: "autorizacao-cibio.visitante",
    ReguladorRead: "autorizacao-cibio.regulador.read",
    ReguladorWrite: "autorizacao-cibio.regulador.write",
    RequisitanteRead: "autorizacao-cibio.requisitante.read",
    RequisitanteWrite: "autorizacao-cibio.requisitante.write",
}